import { Typography } from "@mui/material";
import { type GridRenderCellParams, gridRowNodeSelector, useGridApiContext } from "@mui/x-data-grid-premium";
import type { AgingDetailGridRow } from "./AgingDetailTable.types";

interface FooterCellProps {
  params: GridRenderCellParams<AgingDetailGridRow>;
}
const FooterLabelCell = ({ params }: FooterCellProps) => {
  const apiRef = useGridApiContext();
  const node = gridRowNodeSelector(apiRef, params.id);
  const parentId = node && "parent" in node ? (node.parent as string | null) : null;
  const parentNode = parentId != null ? gridRowNodeSelector(apiRef, parentId) : null;
  const isGroupingTotal = parentNode?.type === "group" && parentNode.groupingKey != null;
  const label = isGroupingTotal ? `Total for ${parentNode.groupingKey}` : "Total";
  return (
    <Typography variant="subtitle2" sx={{ ml: isGroupingTotal ? 3.5 : 0 }}>
      {label}
    </Typography>
  );
};

export default FooterLabelCell;
